import axios from 'axios'
import { toast } from 'react-toastify'
import { t } from 'i18next'

export function registerAxiosInterceptors() {
    axios.interceptors.response.clear()
    axios.interceptors.request.clear()

    axios.interceptors.request.use((req) => {
        if (localStorage.getItem('token')) {
            req.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
        }

        const localStorageItem = localStorage.getItem(req.url!)
        if (localStorageItem) {
            const cachedData = JSON.parse(localStorageItem)

            if (cachedData) {
                req.headers['If-None-Match'] = cachedData.eTag
            }
        }

        req.headers['Accept-Language'] = localStorage.getItem('lang')?.toLowerCase() || 'de'

        return req
    })

    axios.interceptors.response.use(
        async (response) => {
            const eTag = response.headers['etag']
            const url = response.config.url

            if (eTag) {
                // Store ETag and data in localStorage (or any other storage)
                localStorage.setItem(url!, JSON.stringify({ eTag, data: response.data }))
            }

            return response
        },
        (error) => {
            const status = error?.response?.status
            if (status === 401 && !error.config.url.includes('users/me')) {
                localStorage.removeItem('token')
                window.location.href = '/auth/login'
            } else if (status === 422) {
                const errorMsg = error.response.data.detail
                toast.error(errorMsg, { toastId: errorMsg })
            } else if (status === 500) {
                toast.error(t('internalServerError'), { toastId: 'axios-500-error' })
            } else if (status === 304) {
                const url = error.config.url
                const cachedData = JSON.parse(localStorage.getItem(url!)!)
                if (cachedData?.data) {
                    return Promise.resolve({ data: cachedData.data, status: 304, headers: {}, config: error.config })
                }
            }

            throw error
        }
    )
}
